import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const MetaIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<svg
		width="1em"
		height="1em"
		viewBox="0 0 16 16"
		xmlns="http://www.w3.org/2000/svg"
		ref={ref}
		{...props}
	>
		<path
			fill="currentColor"
			d="M11.2654 3.00195C10.0354 3.00195 9.07393 3.93131 8.20357 5.11188C7.00753 3.58411 6.00728 3.00195 4.81027 3.00195C2.36984 3.00195 0.5 6.18816 0.5 9.56057C0.5 11.6709 1.51768 13.002 3.22227 13.002C4.44913 13.002 5.33149 12.4217 6.90009 9.67092C6.90009 9.67092 7.55396 8.51251 8.00379 7.71453C8.16142 7.96985 8.32743 8.24497 8.50183 8.53988L9.2374 9.78126C10.6703 12.1867 11.4686 13.002 12.9152 13.002C14.5758 13.002 15.5 11.6527 15.5 9.4985C15.5 5.96747 13.588 3.00195 11.2654 3.00195ZM5.70394 8.92609C4.43217 10.9261 3.99221 11.3744 3.28414 11.3744C2.55545 11.3744 2.12236 10.7326 2.12236 9.58816C2.12236 7.13988 3.33914 4.63644 4.78964 4.63644C5.57513 4.63644 6.23154 5.09154 7.23699 6.53557C6.28227 8.00468 5.70394 8.92609 5.70394 8.92609ZM10.5038 8.67431L9.62431 7.20283C9.38631 6.81451 9.15758 6.45708 8.93813 6.13053C9.73078 4.90318 10.3846 4.29161 11.1622 4.29161C12.7777 4.29161 14.0701 6.67782 14.0701 9.60885C14.0701 10.7261 13.7054 11.3744 12.9496 11.3744C12.2252 11.3744 11.8792 10.8944 10.5038 8.67431Z"
		></path>
	</svg>
))
